const alertsMixin = {
  methods: {
    success(text, timeout = null) {
      this.sendMessage(text, "green", timeout);
    },

    error(text, timeout = null) {
      this.sendMessage(text, "red", timeout);
    },

    handleRequestError(error, defaultMessage) {
      console.error(error);

      if (error.response && error.response.data.message) {
        this.error(error.response.data.message);
        return;
      }

      this.error(defaultMessage);
    },

    sendMessage(text, color = "", timeout = null) {
      const calculatedTimeout =
        timeout == null ? this.estimateTimeout(text) : timeout;

      console.log("timeout", calculatedTimeout);

      this.$store.commit("sendMessage", {
        text,
        color,
        timeout: calculatedTimeout
      });
    },

    alert(text, timeout = null) {
      this.sendMessage(text, "", timeout);
    },

    estimateTimeout(text) {
      const words = text.split(" ");

      return words.length * 700;
    }
  }
};

export default alertsMixin;
